export const epicAppId = {
    lynx: '22179',
    quai: '17818',
};
//# sourceMappingURL=consts.js.map